import { PrivateRoute } from 'components';
import { useEventContext } from 'contexts/event-context';
import { Routes, Route, Navigate } from 'react-router-dom';
import { EventQuizSelector } from './event-quiz-selector';
import { QuizSetup } from 'pages/quiz-setup';
import { CreateQuiz } from 'pages/quiz-settings';
import { UserProfile } from 'pages/user-profile';
import { QuizSessionQuizSelector } from 'pages/quiz-session';
import { useEffect } from 'react';
import { useCustomTheme, useGlobalContext } from 'contexts';

export const EventRouting = () => {
    const event = useEventContext()!;
    const globalContext = useGlobalContext();
    const themeContext = useCustomTheme();

    useEffect(() => {
        globalContext.setNavTitle(event.name);
        themeContext.setCustomThemes(event.lightThemeStyles, event.darkThemeStyles, event.defaultTheme as "dark" | "light" | "system" | undefined);
    // disabled eslint rule because we want to update the themeContext only when the event changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [event.darkThemeStyles, event.defaultTheme, event.lightThemeStyles, event.name, globalContext]);

    return (
        <Routes>
            {/* private paths */}
            <Route path="/" element={<PrivateRoute eventAlias={event.alias} />}>
                <Route path="/" element={<EventQuizSelector eventId={event.id} />} />
                <Route path="/quiz/create" element={<CreateQuiz />} />
                <Route path="/quiz/:quizId/*" element={<QuizSetup />} />
                <Route path="/session/create" element={<QuizSessionQuizSelector />} />
                <Route path="/profile" element={<UserProfile />} />
                <Route path="/quiz-selector" element={<EventQuizSelector eventId={event.id} />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
        </Routes>
    );
};
